// src/constants/lookupOptions.js

export const FALLBACK_RACES = [
  {"id":1,"name":"Chinese"},
  {"id":2,"name":"Malay"},
  {"id":3,"name":"Indian"},
  {"id":4,"name":"Eurasian"},
  {"id":5,"name":"Bangladeshi"},
  {"id":6,"name":"Myanmarese"},
  {"id":7,"name":"Filipino"},
  {"id":8,"name":"Thai"},
  {"id":9,"name":"Vietnamese"},
  {"id":10,"name":"Indonesian"},
  {"id":11,"name":"Caucasian"},
  {"id":12,"name":"Others"},
  {"id":13,"name":"Burmese"},
  {"id":14,"name":"Bengali"},
  {"id":15,"name":"Myanmar"},
  {"id":16,"name":"Anglo Chinese"},
  {"id":17,"name":"African"},
  {"id":18,"name":"Afghan"},
  {"id":19,"name":"Anglo Indian"},
  {"id":20,"name":"Achehnese"},
  {"id":21,"name":"Albanian"},
  {"id":22,"name":"Armenian"},
  {"id":23,"name":"Annamite"},
  {"id":24,"name":"Ambonese"},
  {"id":25,"name":"Anglo Filipino"},
  {"id":26,"name":"Arab"},
  {"id":27,"name":"Assami"},
  {"id":28,"name":"Austrian"},
  {"id":29,"name":"Australian"},
  {"id":30,"name":"Anglo Saxon"},
  {"id":31,"name":"Aryan"},
  {"id":32,"name":"Azeri"},
  {"id":33,"name":"Batak"},
  {"id":34,"name":"Bulgarian"},
  {"id":35,"name":"Butonese"},
  {"id":36,"name":"Belgian"},
  {"id":37,"name":"Bajau"},
  {"id":38,"name":"Bugis"},
  {"id":39,"name":"Burgher"},
  {"id":40,"name":"Banjarese"},
  {"id":41,"name":"Bangala"},
  {"id":42,"name":"Bhutanese"},
  {"id":43,"name":"Brahmin"},
  {"id":44,"name":"Bisaya"},
  {"id":45,"name":"British"},
  {"id":46,"name":"Boyanese"},
  {"id":47,"name":"Brazilian"},
  {"id":48,"name":"Canadian"},
  {"id":49,"name":"Cape Coloured"},
  {"id":50,"name":"Ceylonese"},
  {"id":51,"name":"Swiss"},
  {"id":52,"name":"Ceylon Moor"},
  {"id":53,"name":"Cocos"},
  {"id":54,"name":"Czechoslovak"},
  {"id":55,"name":"Czech"},
  {"id":56,"name":"Dane"},
  {"id":57,"name":"Dutch Burgher"},
  {"id":58,"name":"Dusun"},
  {"id":59,"name":"Dutch"},
  {"id":60,"name":"Dayak"},
  {"id":61,"name":"English"},
  {"id":62,"name":"European"},
  {"id":63,"name":"Spanish"},
  {"id":64,"name":"Ethiopian"},
  {"id":65,"name":"Egyptian"},
  {"id":66,"name":"Finn"},
  {"id":67,"name":"Fijian"},
  {"id":68,"name":"French"},
  {"id":69,"name":"Gujarati"},
  {"id":70,"name":"Ghanaian"},
  {"id":71,"name":"Gurkha"},
  {"id":72,"name":"German"},
  {"id":73,"name":"Goanese"},
  {"id":74,"name":"Greek"},
  {"id":75,"name":"Hollander"},
  {"id":76,"name":"Hindustani"},
  {"id":77,"name":"Hawaiian"},
  {"id":78,"name":"Iranian"},
  {"id":79,"name":"Iban"},
  {"id":80,"name":"Isoko"},
  {"id":81,"name":"Israeli"},
  {"id":82,"name":"Iraqi"},
  {"id":83,"name":"Irish"},
  {"id":84,"name":"Icelander"},
  {"id":85,"name":"Italian"},
  {"id":86,"name":"Javanese"},
  {"id":87,"name":"Jamaican"},
  {"id":88,"name":"Jordanian"},
  {"id":89,"name":"Japanese"},
  {"id":90,"name":"Jew"},
  {"id":91,"name":"Kachin"},
  {"id":92,"name":"Khasi"},
  {"id":93,"name":"Kenyan"},
  {"id":94,"name":"Khmer"},
  {"id":95,"name":"Kazakh"},
  {"id":96,"name":"Kelabit"},
  {"id":97,"name":"Kampuchean"},
  {"id":98,"name":"Karen"},
  {"id":99,"name":"Korean"},
  {"id":100,"name":"Kadazan"},
  {"id":101,"name":"Lao"},
  {"id":102,"name":"Sri Lankan"},
  {"id":103,"name":"Lebanese"},
  {"id":104,"name":"Libyan"},
  {"id":105,"name":"Malabari"},
  {"id":106,"name":"Moldavian"},
  {"id":107,"name":"Minangkabau"},
  {"id":108,"name":"Malagasy"},
  {"id":109,"name":"Mahratta"},
  {"id":110,"name":"Maori"},
  {"id":111,"name":"Murut"},
  {"id":112,"name":"Makasarese"},
  {"id":113,"name":"Maldivian"},
  {"id":114,"name":"Malayalee"},
  {"id":115,"name":"Melanesian"},
  {"id":116,"name":"Mongolian"},
  {"id":117,"name":"Manipuri"},
  {"id":118,"name":"Marathi"},
  {"id":119,"name":"Metis"},
  {"id":120,"name":"Maltese"},
  {"id":121,"name":"Mauritian"},
  {"id":122,"name":"Mexican"},
  {"id":123,"name":"Melanau"},
  {"id":124,"name":"Naga"},
  {"id":125,"name":"Negro"},
  {"id":126,"name":"Nigerian"},
  {"id":127,"name":"Netherlander"},
  {"id":128,"name":"Norwegian"},
  {"id":129,"name":"Nepalese"},
  {"id":130,"name":"Nauruan"},
  {"id":131,"name":"Newar"},
  {"id":132,"name":"New Zealander"},
  {"id":133,"name":"Penan"},
  {"id":134,"name":"Palestine"},
  {"id":135,"name":"Persian"},
  {"id":136,"name":"Pakistani"},
  {"id":137,"name":"Pole"},
  {"id":138,"name":"Pathan"},
  {"id":139,"name":"Portuguese"},
  {"id":140,"name":"Peruvian"},
  {"id":141,"name":"Parsee"},
  {"id":142,"name":"Polynesian"},
  {"id":143,"name":"Rajput"},
  {"id":144,"name":"Rakhine"},
  {"id":145,"name":"Russian"},
  {"id":146,"name":"Sino Kadazan"},
  {"id":147,"name":"Scot"},
  {"id":148,"name":"Sindhi"},
  {"id":149,"name":"Swede"},
  {"id":150,"name":"Serb/Mont"},
  {"id":151,"name":"Shan"},
  {"id":152,"name":"Sinhalese"},
  {"id":153,"name":"Sino Japanese"},
  {"id":154,"name":"Sikh"},
  {"id":155,"name":"Slovak"},
  {"id":156,"name":"Sumatran"},
  {"id":157,"name":"Serani"},
  {"id":158,"name":"Sudanese"},
  {"id":159,"name":"Sundanese"},
  {"id":160,"name":"Seychellois"},
  {"id":161,"name":"Telugu"},
  {"id":162,"name":"Tibetan"},
  {"id":163,"name":"Tamil"},
  {"id":164,"name":"Tongan"},
  {"id":165,"name":"Turk"},
  {"id":166,"name":"Unknown"},
  {"id":167,"name":"Ukrainian"},
  {"id":168,"name":"American"},
  {"id":169,"name":"Uzbek"},
  {"id":170,"name":"Venezuelan"},
  {"id":171,"name":"Welsh"},
  {"id":172,"name":"Other Indonesian"},
  {"id":173,"name":"Other Eurasian"},
  {"id":174,"name":"Other Indian"},
  {"id":175,"name":"Yugoslav"},
  {"id":176,"name":"Anglo Thai"},
  {"id":177,"name":"Punjabi"}
];

export const FALLBACK_NATIONALITIES = [
  {"id":1,"name":"Afghanistan"},
  {"id":2,"name":"Albania"},
  {"id":3,"name":"Algeria"},
  {"id":4,"name":"Andorra"},
  {"id":5,"name":"Angola"},
  {"id":6,"name":"Antigua and Barbuda"},
  {"id":7,"name":"Argentina"},
  {"id":8,"name":"Armenia"},
  {"id":9,"name":"Australia"},
  {"id":10,"name":"Austria"},
  {"id":11,"name":"Azerbaijan"},
  {"id":12,"name":"Bahamas"},
  {"id":13,"name":"Bahrain"},
  {"id":14,"name":"Bangladesh"},
  {"id":15,"name":"Barbados"},
  {"id":16,"name":"Belarus"},
  {"id":17,"name":"Belgium"},
  {"id":18,"name":"Belize"},
  {"id":19,"name":"Benin"},
  {"id":20,"name":"Bhutan"},
  {"id":21,"name":"Bolivia"},
  {"id":22,"name":"Bosnia and Herzegovina"},
  {"id":23,"name":"Botswana"},
  {"id":24,"name":"Brazil"},
  {"id":25,"name":"Brunei"},
  {"id":26,"name":"Bulgaria"},
  {"id":27,"name":"Burkina Faso"},
  {"id":28,"name":"Burundi"},
  {"id":29,"name":"Cabo Verde"},
  {"id":30,"name":"Cambodia"},
  {"id":31,"name":"Cameroon"},
  {"id":32,"name":"Canada"},
  {"id":33,"name":"Central African Republic"},
  {"id":34,"name":"Chad"},
  {"id":35,"name":"Chile"},
  {"id":36,"name":"China"},
  {"id":37,"name":"Colombia"},
  {"id":38,"name":"Comoros"},
  {"id":39,"name":"Congo (Congo-Brazzaville)"},
  {"id":40,"name":"Costa Rica"},
  {"id":41,"name":"Croatia"},
  {"id":42,"name":"Cuba"},
  {"id":43,"name":"Cyprus"},
  {"id":44,"name":"Czechia (Czech Republic)"},
  {"id":45,"name":"Democratic Republic of the Congo"},
  {"id":46,"name":"Denmark"},
  {"id":47,"name":"Djibouti"},
  {"id":48,"name":"Dominica"},
  {"id":49,"name":"Dominican Republic"},
  {"id":50,"name":"Ecuador"},
  {"id":51,"name":"Egypt"},
  {"id":52,"name":"El Salvador"},
  {"id":53,"name":"Equatorial Guinea"},
  {"id":54,"name":"Eritrea"},
  {"id":55,"name":"Estonia"},
  {"id":56,"name":"Eswatini (fmr. 'Swaziland')"},
  {"id":57,"name":"Ethiopia"},
  {"id":58,"name":"Fiji"},
  {"id":59,"name":"Finland"},
  {"id":60,"name":"France"},
  {"id":61,"name":"Gabon"},
  {"id":62,"name":"Gambia"},
  {"id":63,"name":"Georgia"},
  {"id":64,"name":"Germany"},
  {"id":65,"name":"Ghana"},
  {"id":66,"name":"Greece"},
  {"id":67,"name":"Grenada"},
  {"id":68,"name":"Guatemala"},
  {"id":69,"name":"Guinea"},
  {"id":70,"name":"Guinea-Bissau"},
  {"id":71,"name":"Guyana"},
  {"id":72,"name":"Haiti"},
  {"id":73,"name":"Holy See"},
  {"id":74,"name":"Honduras"},
  {"id":75,"name":"Hungary"},
  {"id":76,"name":"Iceland"},
  {"id":77,"name":"India"},
  {"id":78,"name":"Indonesia"},
  {"id":79,"name":"Iran"},
  {"id":80,"name":"Iraq"},
  {"id":81,"name":"Ireland"},
  {"id":82,"name":"Israel"},
  {"id":83,"name":"Italy"},
  {"id":84,"name":"Jamaica"},
  {"id":85,"name":"Japan"},
  {"id":86,"name":"Jordan"},
  {"id":87,"name":"Kazakhstan"},
  {"id":88,"name":"Kenya"},
  {"id":89,"name":"Kiribati"},
  {"id":90,"name":"Kuwait"},
  {"id":91,"name":"Kyrgyzstan"},
  {"id":92,"name":"Laos"},
  {"id":93,"name":"Latvia"},
  {"id":94,"name":"Lebanon"},
  {"id":95,"name":"Lesotho"},
  {"id":96,"name":"Liberia"},
  {"id":97,"name":"Libya"},
  {"id":98,"name":"Liechtenstein"},
  {"id":99,"name":"Lithuania"},
  {"id":100,"name":"Luxembourg"},
  {"id":101,"name":"Madagascar"},
  {"id":102,"name":"Malawi"},
  {"id":103,"name":"Malaysia"},
  {"id":104,"name":"Maldives"},
  {"id":105,"name":"Mali"},
  {"id":106,"name":"Malta"},
  {"id":107,"name":"Marshall Islands"},
  {"id":108,"name":"Mauritania"},
  {"id":109,"name":"Mauritius"},
  {"id":110,"name":"Mexico"},
  {"id":111,"name":"Micronesia"},
  {"id":112,"name":"Moldova"},
  {"id":113,"name":"Monaco"},
  {"id":114,"name":"Mongolia"},
  {"id":115,"name":"Montenegro"},
  {"id":116,"name":"Morocco"},
  {"id":117,"name":"Mozambique"},
  {"id":118,"name":"Myanmar (formerly Burma)"},
  {"id":119,"name":"Namibia"},
  {"id":120,"name":"Nauru"},
  {"id":121,"name":"Nepal"},
  {"id":122,"name":"Netherlands"},
  {"id":123,"name":"New Zealand"},
  {"id":124,"name":"Nicaragua"},
  {"id":125,"name":"Niger"},
  {"id":126,"name":"Nigeria"},
  {"id":127,"name":"North Korea"},
  {"id":128,"name":"North Macedonia"},
  {"id":129,"name":"Norway"},
  {"id":130,"name":"Oman"},
  {"id":131,"name":"Pakistan"},
  {"id":132,"name":"Palau"},
  {"id":133,"name":"Palestine State"},
  {"id":134,"name":"Panama"},
  {"id":135,"name":"Papua New Guinea"},
  {"id":136,"name":"Paraguay"},
  {"id":137,"name":"Peru"},
  {"id":138,"name":"Philippines"},
  {"id":139,"name":"Poland"},
  {"id":140,"name":"Portugal"},
  {"id":141,"name":"Qatar"},
  {"id":142,"name":"Romania"},
  {"id":143,"name":"Russia"},
  {"id":144,"name":"Rwanda"},
  {"id":145,"name":"Saint Kitts and Nevis"},
  {"id":146,"name":"Saint Lucia"},
  {"id":147,"name":"Saint Vincent and the Grenadines"},
  {"id":148,"name":"Samoa"},
  {"id":149,"name":"San Marino"},
  {"id":150,"name":"Sao Tome and Principe"},
  {"id":151,"name":"Saudi Arabia"},
  {"id":152,"name":"Senegal"},
  {"id":153,"name":"Serbia"},
  {"id":154,"name":"Seychelles"},
  {"id":155,"name":"Sierra Leone"},
  {"id":156,"name":"Singapore"},
  {"id":157,"name":"Slovakia"},
  {"id":158,"name":"Slovenia"},
  {"id":159,"name":"Solomon Islands"},
  {"id":160,"name":"Somalia"},
  {"id":161,"name":"South Africa"},
  {"id":162,"name":"South Korea"},
  {"id":163,"name":"South Sudan"},
  {"id":164,"name":"Spain"},
  {"id":165,"name":"Sri Lanka"},
  {"id":166,"name":"Sudan"},
  {"id":167,"name":"Suriname"},
  {"id":168,"name":"Sweden"},
  {"id":169,"name":"Switzerland"},
  {"id":170,"name":"Syria"},
  {"id":171,"name":"Tajikistan"},
  {"id":172,"name":"Tanzania"},
  {"id":173,"name":"Thailand"},
  {"id":174,"name":"Timor-Leste"},
  {"id":175,"name":"Togo"},
  {"id":176,"name":"Tonga"},
  {"id":177,"name":"Trinidad and Tobago"},
  {"id":178,"name":"Tunisia"},
  {"id":179,"name":"Turkey"},
  {"id":180,"name":"Turkmenistan"},
  {"id":181,"name":"Tuvalu"},
  {"id":182,"name":"Uganda"},
  {"id":183,"name":"Ukraine"},
  {"id":184,"name":"United Arab Emirates"},
  {"id":185,"name":"United Kingdom"},
  {"id":186,"name":"United States of America"},
  {"id":187,"name":"Uruguay"},
  {"id":188,"name":"Uzbekistan"},
  {"id":189,"name":"Vanuatu"},
  {"id":190,"name":"Venezuela"},
  {"id":191,"name":"Vietnam"},
  {"id":192,"name":"Yemen"},
  {"id":193,"name":"Zambia"},
  {"id":194,"name":"Zimbabwe"},
  {"id":195,"name":"Singaporean"},
  {"id":196,"name":"Malaysian"},
  {"id":197,"name":"Chinese"},
  {"id":198,"name":"Indian"},
  {"id":199,"name":"Others"}
];

export async function fetchLookupOptions() {
  try {
    const response = await fetch('https://tms.greenmark.com.sg/api/clients/trainees/lookups/options');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (data && Array.isArray(data.races) && Array.isArray(data.nationalities)) {
      return {
        races: data.races,
        nationalities: data.nationalities
      };
    }
  } catch (error) {
    console.warn("Failed to fetch lookups from API, using fallbacks:", error);
  }
  return {
    races: FALLBACK_RACES,
    nationalities: FALLBACK_NATIONALITIES
  };
}
